import { createMuiTheme } from '@material-ui/core';

const COLORS = {
  green: '#258C83',
  greenLight: '#5CB5AB',
  grey: '#535353',
  black: '#000000',
  mediumGrey: '#939393',
  darkGrey: '#1A1A1A',
  white: '#FFFFFF',
};

export const theme = createMuiTheme({
  palette: {
    primary: {
      main: COLORS.green,
      light: COLORS.greenLight,
      dark: COLORS.green,
    },
    text: {
      primary: COLORS.black,
      secondary: COLORS.grey,
    },
    background: {
      default: COLORS.white,
    },
  },
  typography: {
    fontFamily: 'Poppins',
    button: {
      textTransform: 'none',
      fontSize: '17px',
      fontWeight: 600,
      letterSpacing: '1px',
      width: '104px',
    },
  },
});
